import { render, staticRenderFns } from "./OfertaAdicionalesTrans.vue?vue&type=template&id=28f4dd80"
import script from "./OfertaAdicionalesTrans.vue?vue&type=script&lang=js"
export * from "./OfertaAdicionalesTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports